import { useBehavior } from '@libs/core';
import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { TVerticalLayoutOption } from '../../types/options';
import { VerticalLayoutView } from './VerticalLayoutView';

/**
 * Standalone vertical layout widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior) and delegates rendering to VerticalLayoutView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const VerticalLayoutWidget = ({ widget, children }: React.PropsWithChildren<TWidgetProps<TCommonData, TVerticalLayoutOption>>) => {
    const { isHidden } = useBehavior(widget);

    return (
        <VerticalLayoutView
            uid={widget.uid}
            isHide={isHidden}
            margin={widget.options?.margin}
            alignment={widget.options?.alignment}
            arrangement={widget.options?.arrangement}
            backgroundColor={widget.options?.backgroundColor}
            backgroundImage={widget.options?.backgroundImage}
            styleName={widget.options?.style}
        >
            {children}
        </VerticalLayoutView>
    );
};

export { VerticalLayoutWidget };
